module.exports = __webpack_public_path__ + "static/catch-e5933399450dc375a87a0a52327c8251.png";